import { motion } from "motion/react";

export function HeroSubtleElements() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden select-none z-0">
      {/* Subtle Dot Grid */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
            backgroundImage: "radial-gradient(#64748b 1px, transparent 1px)",
            backgroundSize: "40px 40px",
            maskImage: "radial-gradient(circle at center, black 30%, transparent 80%)"
        }}
      />

      {/* Large Rotating Ring - Dashed */}
      <motion.div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-slate-300 opacity-[0.05]"
        style={{ borderStyle: "dashed", borderWidth: "1px" }}
        animate={{ rotate: 360 }}
        transition={{ duration: 120, repeat: Infinity, ease: "linear" }}
      />
      
      {/* Counter-rotating Inner Ring */}
       <motion.div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[550px] h-[550px] rounded-full border border-[#FD5750] opacity-[0.03]"
        animate={{ rotate: -360 }}
        transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
      />

      {/* Floating Plus Signs (Design/Precision markers) */}
      <FloatingPlus top="15%" left="10%" delay={0} />
      <FloatingPlus top="75%" left="90%" delay={2} />
      <FloatingPlus top="25%" right="10%" delay={4} />
      <FloatingPlus top="80%" left="20%" delay={1.5} />
      
      {/* Subtle Floating Orbs */}
       <motion.div 
         className="absolute w-2 h-2 rounded-full bg-[#FD5750] opacity-20 top-1/3 left-1/4"
         animate={{ y: [-10, 10, -10], opacity: [0.1, 0.3, 0.1] }}
         transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
       />
    </div>
  );
}

function FloatingPlus({ top, left, right, bottom, delay }: any) {
    return (
        <motion.div
            className="absolute text-slate-400 text-xl font-thin opacity-20"
            style={{ top, left, right, bottom }}
            animate={{ 
                opacity: [0.1, 0.4, 0.1], 
                rotate: [0, 180, 0],
                scale: [0.8, 1.2, 0.8]
            }}
            transition={{ duration: 10, repeat: Infinity, delay, ease: "easeInOut" }}
        >
            +
        </motion.div>
    )
}
